module.exports = __webpack_public_path__ + "img/nistalybello.40a785ae.png";